import request from '@/middleware/request'

const getHealth = () => {
  return request({
    url: '/health',
    method: 'get'
  })
}

export default { getHealth }
